import { runInAction } from "mobx";
import { toast } from "react-toastify";
import agent from "../api/agents";
import { CommentAttachmentFormValues } from "../models/commentAttachment";
import { store } from "./store";

export default class CommentAttachmentStore {
    uploading: boolean = false;
    selecting: boolean = false;
    attachmentToBeDeleted: string[] = [];

    add = async (cardId: string, file: File[], message: string, clientId: string) => {
        this.uploading = true;
        try {
            const commentId = await agent.CommentAttachments.add(cardId, file, message.trim(), clientId);
            if (commentId) {
                store.boardStore.hubConnection!.invoke('LoadComments', cardId);
                runInAction(() => this.uploading = false);
                return commentId
            } else {
                return Promise.reject();
            }
        } catch (error) {
            console.log(error);
            runInAction(() => this.uploading = false);
            return Promise.reject();
        }
    }

    updateComment = async (cardId: string, commentId: string, file: File[], message: string, clientId: string) => {
        this.uploading = true;
        try {
           
            const response = await agent.CommentAttachments.update(cardId, commentId, file, message.trim(), clientId);
            if (response) {
                store.boardStore.hubConnection!.invoke('LoadComments', cardId);
                runInAction(() => this.uploading = false);
                return response
            } else {
                return Promise.reject();
            }
        } catch (error) {
            console.log(error);
            runInAction(() => this.uploading = false);
            return Promise.reject();
        }
    }

    getBlob = async (attachmentId: string) => {
        try {
            return await agent.CommentAttachments.getAttachment(attachmentId, {
                responseType: 'blob'
            });
        } catch (e) {
            console.log(e);
        }
    }

    updateFileName = async (fileName: string, id: string) => {
        try {
            store.boardStore.hubConnection?.invoke('UpdateCommentAttachmentFileName', { fileName: fileName, id: id });
        } catch (e) {
            console.log(e);
        }
    }

    deleteAttachment = async (attachmentId: string) => {
        try {
            store.boardStore.hubConnection?.invoke('DeleteCommentAttachment', attachmentId);
            runInAction(() => toast.success('Attachment was deleted successfully.'));
        } catch (e) {
            console.log(e);
        }
    }
}
